var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoConferenceButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4777 0.924072C23.3616 0.879508 23.25 0.857133 23.1428 0.857133C22.9017 0.857133 22.701 0.942132 22.5401 1.11166L16.1428 6.49571V4.28591C16.1428 3.22328 15.7655 2.31493 15.011 1.56039C14.2565 0.805954 13.3482 0.428711 12.2855 0.428711H3.85707C2.79467 0.428711 1.88613 0.805954 1.13155 1.56039C0.377244 2.31493 0 3.22328 0 4.28591V13.7145C0 14.777 0.377244 15.6853 1.13159 16.4398C1.88617 17.1943 2.79471 17.5715 3.85711 17.5715H12.2856C13.3483 17.5715 14.2566 17.1943 15.0111 16.4398C15.7656 15.6853 16.1428 14.7771 16.1428 13.7145V11.4911L22.5402 16.8885C22.7011 17.058 22.9018 17.143 23.1429 17.143C23.2501 17.143 23.3617 17.1206 23.4778 17.0762C23.8262 16.9243 24.0001 16.661 24.0001 16.286L23.1428 9.00024L24.0001 1.71444C24 1.33926 23.826 1.07592 23.4777 0.924072Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoConferenceButton);
export default __webpack_public_path__ + "static/media/videoConferenceButton.1b03be82.svg";
export { ForwardRef as ReactComponent };